import { fillArr, randomNum } from '@hglobal/common';

import { GetFinancialCategoriesRes } from '../models';

export function getFinancialCategoriesMock(count = 14): GetFinancialCategoriesRes {
  return {
    categories: fillArr(count, i => ({
      id: i,
      name: [
        'Urgent payment details update',
        'Incorrect salary',
        'Salary missing',
        'Salary clarification',
        'Bonus clarification',
        'Charges/Accruals clarification',
        'Off-boarding payments clarification',
        'Other',
      ][randomNum(7)],
      description: [
        'Requesting a change of payment information for immediate salary payout today or within 1-2 days',
        'Reporting a wrong salary amount received: higher or lower than expected',
        'Confirming that the salary payment has not been received',
        'Seeking an explanation or further details regarding the salary payment',
        'Seeking an explanation or further details regarding the bonus payment',
        'Question about additional deductions or earnings',
        'Question about final payments upon leaving the company',
        'Any other finance-related question not listed above',
      ][randomNum(7)],
    })),
  };
}
